export default {
  "pregunta": "¿Cuál es un nutriente esencial para el desarrollo muscular en los adolescentes?",
  "opciones": [
    {
      "id": 1,
      "respuesta": "Proteínas",
      "esCorrecta": true
    },
    {
      "id": 2,
      "respuesta": "Azúcares refinados",
      "esCorrecta": false
    },
    {
      "id": 3,
      "respuesta": "Grasas trans",
      "esCorrecta": false
    },
    {
      "id": 4,
      "respuesta": "Bebidas energéticas",
      "esCorrecta": false
    },
    {
      "id": 5,
      "respuesta": "Almidón en exceso",
      "esCorrecta": false
    }
  ]
}